import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'redirect.legacy-routing.flags.error.title',
		defaultMessage: "We can't find the page you're looking for",
		description: 'Title of the flag that tells the user the page could not be found',
	},
	description: {
		id: 'redirect.legacy-routing.flags.error.description',
		defaultMessage:
			"Check your spelling in the address bar. Or, try opening this site's home page to search or browse for the content.",
		description: 'Message shown in the flag that gives user possible actions to recover from error',
	},
	goHome: {
		id: 'redirect.legacy-routing.flags.error.go-home',
		defaultMessage: 'Go to the homepage',
		description: 'Action on the flag that allows user to return to the home page',
	},
});
